export default __webpack_public_path__ + "static/media/CloseTicket.eec52c0e.svg";